import type { MessageReaction, ThreadMessage } from "@rakazo/contracts";
import { canReactToThreadMessage, MESSAGE_REACTIONS } from "@rakazo/contracts";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from "@rakazo/ui-web";
import { Copy, Reply } from "lucide-react";
import type { ReactNode } from "react";
import { copyableMessageText } from "../../lib/message-text";

export function MessageContextMenu({
  message,
  onReply,
  onReference,
  onReact,
  children,
}: {
  message: ThreadMessage;
  onReference?: (message: ThreadMessage) => void;
  onReply: (message: ThreadMessage) => void;
  onReact: (message: ThreadMessage, reaction: MessageReaction) => Promise<void>;
  children: ReactNode;
}) {
  if (message.id.startsWith("progress:")) return children;
  return (
    <ContextMenu>
      <ContextMenuTrigger className="min-w-0 select-text">{children}</ContextMenuTrigger>
      <ContextMenuContent className="rounded-2xl p-2">
        {canReactToThreadMessage(message) ? (
          <>
            <fieldset className="flex gap-1 border-0 p-0" aria-label="Reactions">
              {MESSAGE_REACTIONS.map((emoji) => (
                <ContextMenuItem
                  key={emoji}
                  aria-label={emoji}
                  className="size-10 justify-center rounded-xl text-xl"
                  onClick={() => void onReact(message, emoji)}
                >
                  {emoji}
                </ContextMenuItem>
              ))}
            </fieldset>
            <ContextMenuSeparator />
          </>
        ) : null}
        {onReference && (
          <ContextMenuItem onClick={() => onReference(message)}>
            Reference conversation
          </ContextMenuItem>
        )}
        <ContextMenuItem onClick={() => onReply(message)}>
          <Reply />
          Reply
        </ContextMenuItem>
        <ContextMenuItem
          onClick={() =>
            void navigator.clipboard?.writeText(copyableMessageText(message)).catch(() => undefined)
          }
        >
          <Copy />
          Copy
        </ContextMenuItem>
        {message.runId ? (
          <ContextMenuItem
            onClick={() =>
              void navigator.clipboard?.writeText(message.runId!).catch(() => undefined)
            }
          >
            <Copy />
            Copy request ID
          </ContextMenuItem>
        ) : null}
      </ContextMenuContent>
    </ContextMenu>
  );
}
